import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
	row: {
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "flex-start",
		textAlign: "left",
		margin: "4px 0 12px 8px",
	},
	avatarPlaceholder: {
		alignSelf: "flex-end",
		height: "30px",
		width: "30px",
		marginRight: "12px",
		flexShrink: 0,
	},
	body: {
		padding: "12px 16px",
		backgroundColor: "var(--bot-msg-bg)",
		color: "var(--bot-msg-txt)",
		display: "inline-block",
		borderRadius: "var(--radius-msg) var(--radius-msg) var(--radius-msg) 4px",
		marginRight: "48px",
	},
	loader: {
		height: "6px",
		width: "6px",
		display: "block",
		borderRadius: "50%",
		margin: "4px 14px",
		position: "relative",
		boxShadow: "-12px 0 #fff, 12px 0 #fff",
		animation: "shadowPulse 1s ease infinite",
	},
});

export default function MessageLoader() {
	const classes = useStyles();
	return (
		<div className={classes.row} aria-label="Assistant is typing" role="status">
			<div className={classes.avatarPlaceholder} aria-hidden="true" />
			<div className={classes.body}>
				<div className={classes.loader} />
			</div>
		</div>
	);
}
